<router-outlet></router-outlet>
<ng-template together-page-content-dynamic></ng-template>